export default __webpack_public_path__ + "img/pin_icons/ice_machine_b.svg";